<template>
    <div>
        <nav-bar-main></nav-bar-main> 
        
        <b-alert v-if="plantDetails != null && plantDetails.plant_type == 'basic'" show variant="warning" style="display:inline-block;width:100%">
            <banner-pro/>
        </b-alert>

        <b-alert v-if="plantDetails != null && $store.getters.isProExpired" show variant="warning" style="display:inline-block;width:100%">
            <banner-pro-expired/>
        </b-alert>
        
        <div v-if="error != null" class="alert alert-danger" role="alert">
            {{$t(error)}}
        </div>

        <!-- <Loader /> -->
        <div v-if="plantDetails != null && zoneCollectionDetails != null && zoneScenesDetails != null" class="animated fadeIn container-fluid">
            
            <div style="margin-top: 20px; border-bottom: 2px solid #009DE0">
            <h2><i>{{$store.state.currentZone.zoneName}}</i></h2>
            </div>

            <div style="margin-top:20px">
                <span style="font-size:20px; font-weight: bold;">Aggregazioni</span>
            </div>
            <!-- Tabella Aggregate zones -->
            <div v-if="tableDataCollection">
            
            <b-row>
                <b-col v-for="item in tableDataCollection" v-bind:key="item.collectionId" xl="2" lg="4" md="6" class="mt-4">
                    <b-button class="button-zone-detail">
                        <span style="font-size:20px; font-weight: bold;"> {{collection(item.collectionId).collectionName}}</span>
                        <br>
                        <b-row style="margin-top:15px">
                            <b-col cols="3">
                                <b-button @click="setSliderMin(item)" style="color: #0090CD">
                                    OFF
                                </b-button>
                            </b-col>
                            <b-col>
                                <vue-slider :min="0" :max="100" v-model="item.lightLevel" class="slider"/>
                            </b-col>
                            <b-col cols="3">
                                <b-button @click="setSliderMax(item)" style="color: #0090CD">
                                    ON
                                </b-button>
                            </b-col>    
                        </b-row>
                        <br>
                        <b-button @click="activateCollection(item)" class="typo-butt-add but-add">
                            Applica
                        </b-button>

                    </b-button>
                </b-col>       
            </b-row>

            </div>
            
            <div style="margin-top:20px">
                <span style="font-size:20px; font-weight: bold;">Scene</span>
            </div>
            <!-- Tabella Scenari zones -->
            <div v-if="tableDataScenes" >
           
            <b-row>
                <b-col v-for="item in tableDataScenes" v-bind:key="item.sceneId" xl="2" lg="4" md="6" class="mt-4">
                    <b-button class="button-zone-detail">
                        <span style="font-size:20px; font-weight: bold;">{{item.sceneName}}</span>
                        <br>
                        <b-row style="margin-top:15px">
                            <b-col cols="8">
                                <span>Programmazione attiva</span>
                            </b-col>
                            <b-col cols="4" @click="activeScene(item.id)">
                                <switches v-model="item.active" style="margin-top:6px"></switches>   
                            </b-col>
                        </b-row>
                        <br>
                        <b-button @click="saveZone()" class="typo-butt-add but-add">
                            Applica
                        </b-button>

                    </b-button>
                </b-col>       
            </b-row>

            </div>

        </div>

    </div>
</template>

<script>

import Vue from 'vue'

import NavBarMain from '@/components/NavBarMain'
import DisclaimerPhotoITA from '@/locales/DisclaimerPhotoITA';
import DisclaimerPhotoENG from '@/locales/DisclaimerPhotoENG';
import DisclaimerPhotoGER from '@/locales/DisclaimerPhotoGER';
import BannerProExpired from '@/components/BannerProExpired';
import BannerPro from '@/components/BannerPro';
import {showAt, hideAt} from 'vue-breakpoints';
//import DragItDude from 'vue-drag-it-dude';
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import Switches from 'vue-switches';

import panZoom from 'vue-panzoom'
Vue.use(panZoom);

import jsPDF from 'jspdf';
import JsPDFAutotable from 'jspdf-autotable' ;



import { mapState } from 'vuex';

export default {
    name: 'ZoneDetail',
    components: {
        NavBarMain,
        Event,
        BannerPro,
        BannerProExpired,
        DisclaimerPhotoENG,
        DisclaimerPhotoITA,
        DisclaimerPhotoGER,
        vueDropzone: vue2Dropzone,
        jsPDF,
        JsPDFAutotable,
        hideAt, 
        showAt,
        VueSlider,
        Switches
    },
    props: ['plantId','zoneId'],
    data() {
        return {
            
        }     
    
    },
    filters: {
        
        tipoCentrale: function(value) {
            if (value == 'cablecom') return "Centrale CableCom"
            return "Centrale " + value
        },
        
    },
    computed: {
        ...mapState(['loading','error','commandsPending','commandResponse']),

        rndId() {
            return Math.random();
        },
        plantDetails() {
            const plant = this.$store.state.currentPlant;
            if (plant == null){
                this.tableDataCollection = [];
                this.tableDataScenes = [];
                return null;
            } 
            if (plant.id != this.plantId) return null;
            return plant;
        },
        
        zoneCollectionDetails(){
            if (this.$store.state.plantCollections == null) return null;
            this.tableDataCollection = this.$store.state.currentZone.collections.map((c) => { return {collectionId: c, lightLevel: 0}; });
            console.log("Zones collection: ",this.tableDataCollection);
            return this.tableDataCollection;
        },
        zoneScenesDetails(){
            var self = this;
            this.tableDataScenes = this.$store.state.currentZone.scenes.map(s => {
                var scene = self.scene(s);
                if (scene == null) return {};
                return {sceneId: scene.sceneId, sceneName: scene.sceneName, active: true};
            });
            
            console.log("Zones scenes: ",this.tableDataScenes);
            return this.tableDataScenes;
        },
        unitsDetails() {
            return this.$store.state.plantUnits;
        },
        allTableData() {
            return this.$store.state.plantUnits || [];
        },    
    },
    mounted() {
        console.log("zoneDetail mounted, idImpianto=" + this.plantId + ", plantDetails:" + this.plantDetails+", zone id:" + this.zoneId+", collections:", this.$store.state.plantCollections)
        //window.addEventListener('resize', this.handleResize)

        if (this.plantDetails != null && this.$store.state.plantCollections == null) {
            console.log("zoneDetail, ricarico plantCollections")
            this.$store.dispatch('loadPlantCollections', this.plantId);
        }
        
        /*if (this.$store.state.user != null && this.error == null && this.plantDetails == null && !this.$store.state.connecting && this.$store.state.socket != null && this.$store.state.socket.isConnected) {
            this.$store.dispatch('loadPlantZones', this.plantId)
        } else {
            let self = this;
            this.$nextTick(() => {
                self.$forceUpdate();
            });
        }*/
    },
    updated() {
        //console.log("dispositiviImpianto updated, idImpianto=" + this.plantId+", plantDetails=", this.plantDetails+ ", error:" + this.error)
        /*if (this.plantDetails == null && this.zoneCollectionDetails == null && this.zoneSensorDetails == null && this.error == null && this.$store.state.user != null) {
            this.$store.dispatch('loadPlantZones', this.plantId)
        } */
    },
    
    watch: {
        loading(val,oldval) {
            console.log("zone details loading changed:" + val+", error=" + this.error)
            
            if (val == false && this.error == null) {
                
            }

            /*if (val == false && this.plantDetails == null && this.error == null) {
                this.$store.dispatch('loadPlantDetails', this.plantId)
            } else if (val == false && this.plantDetails != null && this.unitsDetails == null && this.error == null) {
                console.log("carico units details")
                this.$store.dispatch('loadUnitsDetails', this.plantId)
            } else if (val == false && this.$store.state.commandResponse.pending == false && this.$store.state.commandResponse.command != null) {
                console.log("zone detail devo elaborare risposta comando ", this.$store.state.commandResponse);
                
            } else if (val == false && this.plantDetails != null && this.unitsDetails != null) {
                console.log("dati pronti");

            }
            this.$forceUpdate();*/
        },
        unitsDetails(val,oldval) {
            console.log("aggiornato unitsDetails",val,oldval);
        },
        commandsPending(val,oldval) {
            console.log("commandsPending " + val, "configInProgress =" + this.configInProgress);   
        },
        commandResponse(val,oldval) {
            console.log("updated commandResponse:",val);
            if (val.command == 'disclaimerPhotoAccepted'&& val.pending == false) {
                this.aggiungiPianta();       
            } 
        }
    },
    methods: {
        collection(id) {
            console.log("cerco aggregazione " + id, this.$store.state.plantCollections)
            var coll = this.$store.state.plantCollections.find(c => c.collectionId == id);
            console.log("trovato:",coll);
            if (coll != null) return coll; 
            return {};
        },
        scene(id) {
            console.log("cerco scena " + id, this.$store.state.plantScenes)
            var scene = this.$store.state.plantScenes.find(c => c.sceneId == id);
            console.log("trovato:",scene);
            if (scene != null) return scene; 
            return {};
        },
        ruoloUtente(id) {
            let pusers = this.$store.state.currentPlant.plant_users;
            if (pusers == null || pusers.length == 0) return "?";
            let user = pusers.filter(function(u){
                return u.userid == id;
            });
            if (user != null && user.length > 0) 
            {
               return user[0].role;
            }
            return "?";
        },
        mostraPaginaCentrali() {
            this.$router.push({name: 'Centrali', params: {pid: this.$store.state.currentPlant.id}})
        },
        mostraPaginaTuttiDispositivi() {
            this.$router.push({name: 'TuttiDispositivi', params: {pid: this.$store.state.currentPlant.id}})
        },
        mostraPaginaPlanimetrie() {
            this.$router.push({name: 'Planimetrie', params: {pid: this.$store.state.currentPlant.id}})
        },
        mostraPaginaAmbienti() {
            this.$router.push({name: 'Ambienti', params: {pid: this.$store.state.currentPlant.id}})
        },
        mostraPaginaPlanimetrie() {
            this.$router.push({name: 'Planimetrie', params: {pid: this.$store.state.currentPlant.id}})
        },
        mostraPaginaZone() {
            this.$router.push({name: 'Zone', params: {pid: this.$store.state.currentPlant.id}})
        },
        mostraPaginaGestioneZone() {
            this.$router.push({name: 'GestioneZone', params: {pid: this.$store.state.currentPlant.id}})
        },
        apertoDettaglioMappa() {
            this.tabIndex = 0;
            console.log("Aperto dettaglio " + this.currentAmbiente.isNew);
            if (this.currentAmbiente.isNew) {
                this.showDropZone = true;

            }
        },
        setSliderMin(item){
            //var objIndex =  this.tableDataCollection.findIndex((obj => obj.id == id));
            //this.tableDataCollection[objIndex].illuminazione = 0;
            item.lightLevel = 0;
            this.$forceUpdate();
            
        },
        setSliderMax(item){
            console.log("item -->",item);
            //var objIndex =  this.tableDataCollection.findIndex((obj => obj.id == id));
            //this.tableDataCollection[objIndex].illuminazione = 100;
            item.lightLevel = 100;
            this.$forceUpdate();
        },
        activateCollection(item) {
            console.log("attiva aggregazione", item);
        },
        activeScene(id){
            var objIndex =  this.tableDataScenes.findIndex((obj => obj.id == id));
            var oldVal = this.tableDataScenes[objIndex].active;
            this.tableDataScenes[objIndex].active = !oldVal;
            this.$forceUpdate();
        },
        saveZone(){

        }
    }
}
</script>

<style lang="scss">

.slider{
    margin-top: 10px;
}

.button-zone-detail{
    height: 250px;
    width: 250px;
}

.close-x{
    font-size: 1.3125rem;
    font-weight: 400; 
    color: white;
    opacity:1;
}

.modal-fullscreen .modal-dialog {
    max-width: 100%;
    margin: 0;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100vh;
    z-index: 100000;
}
    .nopad {
       padding: 0;
    }
    .imgDiv {
        position: relative;
    }

    .dotImg {
        position: absolute;
        display: block;
        top: 0;
        left: 0;
        float: left;
        width: 13px;
        height: 13px;
        
    }

    @keyframes highlightedDotAnim {
        0% {background-color: rgba(255,255,255,0);}
        50% {background-color: rgba(255,255,0,0.8);}
        100% {background-color: rgba(255,255,255,0);}
    }

    .dotImgHighlight {
        background-color: #ffff00;
        width: 61px;
        height: 61px;
        padding: 24px;
        border-radius: 32px;
        animation-name: highlightedDotAnim;
        animation-duration: 1s;
        animation-iteration-count: infinite;
    }

    .dotImgBig {
        position: absolute;
        display: block;
        top: 0;
        left: 0;
        float: left;
        width: 50px;
        height: 50px;
        padding: 16px;
        background-color: #ffffff11;
        border-radius: 32px;
        z-index: 10000;
    }

    .dotSel {
        background-color: #00990044;
    }

    .modal-xl {
        max-width: 95%;
        
    }
    .uploadButton {
        position: absolute;
        left: 0;
        bottom: 0;
    }

    .infoTip {
        position: absolute;
        right: 5px;
        bottom: 5px;
    }

    .closeButton {
        position: absolute;
        right: 0;
        top: 0;
    }

    #dropzoneContainer {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: #eeeeee;
        top: 0;
        margin-top: auto;
        margin-bottom: auto;
        padding: 16px;
        z-index: 11000;
    }
    #dropzone {
        height: 100%;
    }
    .draggableRow {
        cursor: pointer;
    }

    .lampUsed {
        background-color: #ffff;
    }

    .highlightedRow {
        background-color: #b3d3ec;
    }
    
    .highlightedAdded {
        background-color: #ffff;
    }


    .green {
        color: #009900;
    }
    .error {
        color: #cc0000;
    }

    #modal-ambiente .modal-content {
        min-height: 600px;
    }

</style>